const routes = {
  proaq: '/api/proaq',
  proaqfase: '/api/proaqfase',
  proaqitem: '/api/proaqitem',
  pesquisapreco: '/api/pesquisapreco',
  tipomodalidade: '/api/tipomodalidade',
  subtipomodalidade: '/api/subtipomodalidade',
  proaqresponsavel: '/api/proaqresponsavel',
  kitporcomponete: '/api/kitproduto/kits-por-componente/:componenteNumber',
  denomicacoesporcomponente:
    '/api/denominacaogenerica/denominacoes-por-componente/:componenteLabel',
};

export default routes;
